import React from 'react';
import { Menu, MenuItem } from '@material-ui/core';

export default ({
  anchorEl,
  handleClose,
  markAsRead,
  markAsImportant,
  handleDelete,
  read,
  featured
}) => (
  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
    <MenuItem onClick={markAsRead}>
      {read ? 'Marcar como no leída' : 'Marcar como leída'}
    </MenuItem>
    <MenuItem onClick={markAsImportant}>
      {featured ? 'Marcar como no importante' : 'Marcar como importante'}
    </MenuItem>
    <MenuItem onClick={handleDelete}>Eliminar notificación</MenuItem>
  </Menu>
);
